import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    contentHeight: '',
    ip: '',
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : {},
    isCreatePage: true,
    comPerResCounts: '',//全局统计企业、人员、成果数量
    /* 常规条件 */
    advAndTagArr: sessionStorage.getItem('advAndTagArr') ? JSON.parse(sessionStorage.getItem('advAndTagArr')) : [],
    /* 高级检索-输入框条件 */
    advInputTagArr: sessionStorage.getItem('advInputTagArr') ? JSON.parse(sessionStorage.getItem('advInputTagArr')) : [],
    vsList: localStorage.getItem('vsList') ? JSON.parse(localStorage.getItem('vsList')) : [],
    /* 所有模块配置数据 */
    allModuleInfo: sessionStorage.getItem('allModuleInfo') ? JSON.parse(sessionStorage.getItem('allModuleInfo')) : [],
    /* 领域匹配页面所需的统计和检索条件 */
    areaConditionObj: sessionStorage.getItem('areaConditionObj') ? JSON.parse(sessionStorage.getItem('areaConditionObj')) : {},
  },
  getters: {
  },
  mutations: {
    setContentHeight(state, height) {
      state.contentHeight = height
    },
    setIp(state, ip) {
      state.ip = ip
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo || {}
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo || {}))
    },
    isCreatePage(state, isCreatePage) {
      state.isCreatePage = isCreatePage
    },
    comPerResCounts(state, comPerResCounts) {
      state.comPerResCounts = comPerResCounts
    },
    advAndTagArr(state, advAndTagArr) {
      state.advAndTagArr = advAndTagArr
      sessionStorage.setItem('advAndTagArr', JSON.stringify(advAndTagArr))
    },
    advInputTagArr(state, advInputTagArr) {
      state.advInputTagArr = advInputTagArr
      sessionStorage.setItem('advInputTagArr', JSON.stringify(advInputTagArr))
    },
    // 存对比数据
    vsList(state, vsList) {
      state.vsList = vsList
      localStorage.setItem('vsList', JSON.stringify(state.vsList))
    },
    // 删除对比数据
    delVsItem(state, index) {
      state.vsList.splice(index, 1)
      localStorage.setItem('vsList', JSON.stringify(state.vsList))
    },
    // 重置对比数据
    resetVsData(state) {
      state.vsList = []
      localStorage.setItem('vsList', [])
    },
    // 更换对比数据
    delAndInsertVsItem(state, item) {
      const { vsItem, index } = item
      state.vsList.splice(index, 1, vsItem)
      localStorage.setItem('vsList', JSON.stringify(state.vsList))
    },
    saveAllCfgModule(state, allModuleInfo) {
      state.allModuleInfo = allModuleInfo
      sessionStorage.setItem('allModuleInfo', JSON.stringify(allModuleInfo))
    },
    saveAreaObj(state, areaConditionObj) {
      state.areaConditionObj = areaConditionObj
      sessionStorage.setItem('areaConditionObj', JSON.stringify(areaConditionObj))
    }
  },
  actions: {
  },
  modules: {
  }
})
